import { CloseOutlined } from "@ant-design/icons";
import { Form, FormInstance, FormProps, Input, Modal, Select, Switch, TreeSelect } from "antd";
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useRef, useState } from "react";
import useToast from "../../../../hook/useToast";
import { addMessagingProviderConfig, IProvider } from "../../../../api/generalConfiguration/generalConfigurationApi";
import { fommatSelectOption, fommatSelectOptionUnitByUser } from "../../../../until";
import '../styles.scss'
import { useSelector } from "react-redux";
import { selectorUnitByUserPermission } from "../../../../store/slices/UnitByUserPermission";
import { getSLUnitByPermission, getSLZnsProvider, ISelectOption } from "../../../../api/selectOptions/selectOptionsApi";
import useLoading from "../../../../hook/useLoading";
import useThrottle from "../../../../hook/useThrottle";
import { addZnsConfig, checkDuplicateZns, editZnsConfig, IZnsConfig } from "../../../../api/integrationProvider/integrationProvidersApi";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { convertNationwideValueToTree_V2 } from "../../../../api/unit/unitApi";
import { TreeSelectCustom_V2 } from "../../AccountsManagement/Components/TreeSelectCustom_V2";

interface ModalProps {
  isOpen: boolean
  sLCategoryCar: ISelectOption[]
  infoZnsConfig?: IZnsConfig
  onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
  closeModal: () => void
}


const ModalUpdateZNS: React.FC<ModalProps> = ({
  isOpen,
  sLCategoryCar, infoZnsConfig,
  onSubmitFormModal, closeModal
}) => {

  useEffect(() => {


    let unmounted = false;
    (async () => {
      const [resNationwide] = await Promise.all([getSLUnitByPermission(unitTemp),
      ]);
      if (!unmounted && resNationwide?.status) setSLNationwide(convertNationwideValueToTree_V2(resNationwide.data));
    })();

  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading()
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)
  const { unitTemp, id } = useSelector(selectorInfoUser)

  const [form] = useForm();

  const [sLZnsProvider, setSLZnsProvider] = useState<ISelectOption[]>([])
  const [sLNationwide, setSLNationwide] = useState<any>()
  const [valuesUnitList, setValuesUnitList] = useState<number[]>([]);

  const gSLZnsProvider = async () => {
    const result = await getSLZnsProvider()
    if (result?.status) {
      setSLZnsProvider(fommatSelectOption(result.data))
    }
  }


  const onFinish: FormProps["onFinish"] = useThrottle(async (values: any) => {
    if (!infoZnsConfig?.id) return
    const { brandName, unitIds, categoryCarIds, username, password } = values

    pushLoading(true)
    // const resultCheck = await checkDuplicateZns(
    //   zaloOASecretKey, zaloRefreshToken,
    //   infoZnsConfig?.id
    // )
    // if (resultCheck.data.duplicateOASecretKey || resultCheck.data.duplicateRefreshToken) {
    //   form.setFields([
    //     {
    //       name: "zaloOASecretKey",
    //       errors: resultCheck.data.duplicateOASecretKey
    //         ? ["Zalo OA Secret Key đã tồn tại"]
    //         : [],
    //     },
    //     {
    //       name: "zaloRefreshToken",
    //       errors: resultCheck.data.duplicateRefreshToken
    //         ? ["Zalo Refresh Token đã tồn tại"]
    //         : [],
    //     },
    //   ])

    //   pushLoading(false)
    //   return
    // }

    // pushLoading(false)

    // pushLoading(true)
    const result = await editZnsConfig(
      infoZnsConfig.id, brandName,unitIds, categoryCarIds, username, password
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
    pushLoading(false)
  }, 1000)

  useEffect(() => {
    if (isOpen) {
      // if (!sLZnsProvider.length)
      gSLZnsProvider()
      if (infoZnsConfig) {
        const { brandName, categoryCarIds, unitIds, username,password  } = infoZnsConfig
        setValuesUnitList(unitIds || [])

        form.setFieldsValue({
          brandName,
          unitIds,
          categoryCarIds,
          username,
          password
        });
      }

    } else {
      setValuesUnitList([])
      form.resetFields();
    }
  }, [isOpen])
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Cập nhật cấu hình ZNS</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal-572 modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={() => form.submit()}>
          Tạo
        </button>
      </div>}
    >
      <Form
        form={form}
        onFinish={onFinish}
      >
        <div className="d-flex flex-column gap-18-px p-6">
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Brandname:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name="brandName"
              className="m-none-form-item text-explan"
              rules={[{ required: true, message: 'Vui lòng nhập brandname!' }]}
            >
              <Input
                placeholder="Brandname"
                className="custom-input-css"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Thương hiệu hãng xe:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name="categoryCarIds"

              rules={[{ required: true, message: 'Chọn tên thương hiệu hãng xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                placeholder="Thương hiệu hãng xe"
                mode="multiple"
                className="custom-page-css border rounded overflow-hidden"

                options={sLCategoryCar}

                onChange={(values) => {
                  if (!values) return;
                  const hasAll = values.includes(-1);
                  if (hasAll && values.length > 1) {
                    const onlyAll = values[values.length - 1] === -1;
                    form.setFieldValue(
                      "categoryCarIds",
                      onlyAll ? [-1] : values.filter((v: any) => v !== -1)
                    );
                  }
                }}
              />
            </Form.Item>
          </div>

          {/* <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Phạm vi hoạt động:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name="unitIds"
              rules={[{ required: true, message: 'Chọn phạm vi hoạt động!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                mode="multiple"   // ✅ cho phép chọn nhiều
                placeholder="Phạm vi hoạt động"
                className="custom-page-css border rounded overflow-hidden"
                showSearch={false}
                // ✅ Ẩn tag mặc định
                maxTagCount={0}

                // ✅ Hiển thị số lượng đã chọn
                maxTagPlaceholder={(values) => (
                  <span className="selected-counter">
                    {values.length} đơn vị được chọn
                  </span>
                )}
                options={fommatSelectOptionUnitByUser(unitByUserPermissionSlice)}
              />

            </Form.Item>
          </div> */}

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Phạm vi hoạt động:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name='unitIds'
              className="m-none-form-item text-explan h-full w-full custom-css-select"
              rules={[{ required: true, message: 'Chọn phạm vi hoạt động!' }]}
            >

              <TreeSelectCustom_V2
                className="h-full w-full custom-css-select custom-page-css rounded border"
                data={sLNationwide || []}
                // value={selectedIds}                              // ví dụ: [101, 205]
                value={valuesUnitList}
                onChange={(ids) => {
                  setValuesUnitList(ids);
                  form.setFieldValue('unitIds', ids);
                }}   // nhận về [number, ...]
                cascadeDisable={true}
                disableMode="disabled"                           // hoặc "disableCheckbox" nếu chỉ muốn khoá tick
              />
              {(valuesUnitList.length ?? 0) > 0 && (
                <p className="bg-F0F5FF border-ADC6FF rounded-2 text-2F54EB text-sm px-2 d-flex align-center gap-3-px h-auto font-regular justify-between absolute custom-css-count-select">
                  {valuesUnitList.length} đơn vị được chọn
                </p>
              )}
            </Form.Item>


          </div>

         <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Username:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Nhập Username!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Username"
                className="custom-input-css"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 ">
              Password:<span className="text-F5222D">*</span>
            </p>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Nhập Password!' }]}
              className="m-none-form-item text-explan"
            >
              <Input.Password
                placeholder="Password"
                className="custom-input-css"
              />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  )
}
export default ModalUpdateZNS
